var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"orange-white btn width-md mb-3",attrs:{"type":"submit","disabled":_vm.disabled},domProps:{"value":_vm.$t(_vm.text)},on:{"click":function($event){_vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }